'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JsColor = function (_React$Component) {
    _inherits(JsColor, _React$Component);

    /**
     * JsColor Constructor
     * @param {*} props
     */
    function JsColor(props) {
        _classCallCheck(this, JsColor);

        // Initial state
        var _this = _possibleConstructorReturn(this, (JsColor.__proto__ || Object.getPrototypeOf(JsColor)).call(this, props));

        _this.state = {
            color: props.value
        };

        /**
         * Create references
         */
        _this.colorInput = React.createRef();

        // Bind methods
        _this.onChange = _this.onChange.bind(_this);
        _this.showColorPicker = _this.showColorPicker.bind(_this);
        return _this;
    }

    /**
     * Component mounted
     */


    _createClass(JsColor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Setup jscolor
            window.jscolor.installByClassName('jscolor-input');
            this.colorInput.current.addEventListener('change', this.onChange);
            this.colorInput.current.addEventListener('input', this.onChange);

            // Set background and color
            this.colorInput.current.style.background = this.state.color;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.value !== this.state.color) {
                this.colorInput.current.style.background = this.props.value;
            }
        }

        /**
         * Component will unmount
         */

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.colorInput.current.removeEventListener('change', this.onFineChange);
            this.colorInput.current.removeEventListener('input', this.onFineChange);
        }

        /**
         * On JsColor value change
         */

    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _this2 = this;

            // Set state and call parent methods upon success set
            this.setState({ color: this.colorInput.current.jscolor.toHEXString() }, function () {
                _this2.colorInput.current.style.background = _this2.state.color;
                _this2.props.onChange(e, _this2.state.color);
            });
        }
        /**
         * Show color picker
         */

    }, {
        key: 'showColorPicker',
        value: function showColorPicker() {
            this.colorInput.current.jscolor.show();
        }

        /**
         * Render component
         */

    }, {
        key: 'render',
        value: function render() {
            return React.createElement('input', {
                spellcheck: 'false',
                id: this.props.id,
                className: 'jscolor-input',
                value: this.props.value,
                onChange: this.props.onChange,
                onFocus: this.showColorPicker,
                ref: this.colorInput,
                maxLength: '7'
            });
        }
    }]);

    return JsColor;
}(React.Component);